import {
    InitialCausalityFilter,
    InitialCausality,
    InitialCausalityHistorical,
} from '../shared/types/typifications/initialCausality';
import { apiService } from './index';

export const asyncGetInitialCausalitys = async (
    filters: InitialCausalityFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: InitialCausality[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: InitialCausality[]; length: number };
        } = await apiService.get('/api/initial-causality', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetInitialCausality = async (
    idInitialCasuality: string
): Promise<InitialCausality | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: InitialCausality;
        } = await apiService.get(
            `/api/initial-causality/${idInitialCasuality}`
        );
        return data;
    } catch (error) {}
};

export const asyncCreateInitialCausality = async (
    info: InitialCausality
): Promise<InitialCausality | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: InitialCausality;
        } = await apiService.post('/api/initial-causality', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateInitialCausality = async (
    id: string,
    casesGeneral: InitialCausality
): Promise<InitialCausality | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: InitialCausality;
        } = await apiService.patch(
            `/api/initial-causality/${id}`,
            casesGeneral
        );

        return data;
    } catch (error) {}
};

export const asyncGetInitialCausalityHistorical = async (
    idInitialCasuality: string
): Promise<InitialCausalityHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: InitialCausalityHistorical[];
        } = await apiService.get(
            `/api/initial-causality/${idInitialCasuality}/historical`
        );
        return data;
    } catch (error) {}
};
